import { Certificate } from "./certificate";
import { ProvinceMultiple } from "../../province-multiple";
import { Ajax } from "../../ajax";
import { Center } from "./form/center";
import { Currency } from "./form/currency";
import { Cities } from "./form/cities";
import { Notifications } from "../../notifications";
import { Services } from "./form/services";
export class Bulk {
    constructor(form) {
        this.form = form;
        this.examsWrapperSelector = ".js-exams";
        this.sending = false;
        this.certificateSelect = this.form.querySelector(Bulk.certificateSelectSelector);
        this.certificates = this.createCertificates();
        this.setToggleCertificateOnCertificateChanged();
        form
            .querySelectorAll(ProvinceMultiple.provinceContainerSelector)
            .forEach((provinceContainer) => {
            new ProvinceMultiple(provinceContainer);
        });
        form.addEventListener("submit", (event) => {
            event.preventDefault();
        });
        form.querySelector("#send-bulk-button").addEventListener("click", () => {
            this.send();
        });
    }
    get inputHandlers() {
        return [
            new Services(this.form),
            new Center(this.form),
            new Currency(this.form),
            new Cities(this.form),
            this.currentCertificate,
        ];
    }
    send() {
        if (this.sending) {
            return;
        }
        this.sending = true;
        this.disableForm();
        const formData = new FormData();
        const isFormValid = this.inputHandlers.every((currentValue) => currentValue.validate());
        if (!isFormValid) {
            return;
        }
        this.inputHandlers.forEach((inputHandler) => {
            inputHandler.addToFormData(formData);
        });
        const ajax = new Ajax(this.form.action, "POST");
        ajax.data = formData;
        ajax.errorCallback = (data) => this.onSendingError(data);
        ajax.successCallback = (data) => this.onSendingSuccess(data);
        ajax.send();
    }
    disableForm() {
        this.form
            .querySelectorAll("input, select")
            .forEach((input) => {
            input.setAttribute("disabled", "disabled");
        });
    }
    enableForm() {
        this.form
            .querySelectorAll("input, select")
            .forEach((input) => {
            input.removeAttribute("disabled");
        });
    }
    onSendingSuccess(data) {
        this.sending = false;
        if (!data.error) {
            Notifications.successCookie(sessionSaved, "");
            window.history.back();
        }
        this.enableForm();
    }
    onSendingError(data) {
        this.sending = false;
        this.enableForm();
    }
    setToggleCertificateOnCertificateChanged() {
        this.certificateSelect.addEventListener("change", () => {
            this.notifyCertificateChange(this.certificateSelect);
        });
        this.notifyCertificateChange(this.certificateSelect);
    }
    notifyCertificateChange(certificateSelect) {
        this.certificates.forEach((certificate) => {
            certificate.onSelectedCertificateChanged(certificateSelect.value);
        });
    }
    get currentCertificate() {
        return this.certificates.find((certificate) => certificate.certificateId === this.certificateSelect.value);
    }
    createCertificates() {
        const certificates = [];
        this.form
            .querySelectorAll(this.examsWrapperSelector)
            .forEach((wrapper) => {
            certificates.push(new Certificate(wrapper));
        });
        return certificates;
    }
    static init() {
        const form = document.querySelector("form.js-exam-bulk");
        if (form) {
            new Bulk(form);
        }
    }
}
Bulk.certificateSelectSelector = "select.js-certificate-select";
